import { connect } from "react-redux";
import HotelStructure from "./HotelStructure";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as roomsActions from "../actions";
import { getCleaningList } from "../../cleaning/actions";
import { getOccupancy } from "../occupancy/actions";
import { getSyncUser } from "../../synchronization/actions";
import Loader from "../../components/Loader";
import { bindActionCreators } from "redux";
import { isAdmin, isSynchronizing } from "../../users/selectors";
import { LOADING } from "../../utils/helpers/phases";
import { translate, Trans } from "react-i18next";
import { Message } from "semantic-ui-react";
import { getVisibleRooms } from "../selectors";
import { getUsers } from "../../users/actions";
class HotelStructureContainer extends Component {
  state = { visible: false, occupancy: {} };
  toggleModal = occupancy =>
    this.setState(prevState => ({
      visible: !prevState.visible,
      occupancy
    }));

  async componentDidMount() {
    if (this.props.rooms.length === 0) {
      await this.props.getRooms();
    }
    if (this.props.cleaning.length === 0) {
      await this.props.getCleaningList();
    }

    if (this.props.users.length === 0) {
      await this.props.getUsers();
    }
    await this.props.getSyncUser();
    await this.props.getOccupancy();
  }

  render() {
    if (this.props.roomPhase === LOADING) {
      return <Loader />;
    }
    if (this.props.rooms.length === 0)
      return (
        <Message>
          <Message.Content>
            <Trans i18nKey="message:dashboard:tipsMessageText">
              <div>
                <p>
                  Za chwilę zaczniesz tworzyć strukturę swojego hotelu.
                  Wszystkie opcje, które pozwolą Ci sprawnie rozpocząć pracę
                  znajdują się w menu <strong>Ustawienia</strong>:
                </p>
                <ul>
                  <li>
                    zacznij od stworzenia typów pokoi (
                    <strong>Typy pokoi</strong>)
                  </li>
                  <li>
                    następnie utwórz w aplikacji pokoje (<strong>Pokoje</strong>
                    )
                  </li>
                  <li>
                    dodaj konta dla pracowników (<strong>Użytkownicy</strong>)
                  </li>
                </ul>
                <p>
                  Po utworzeniu struktury pokoi i kont dla pracowników, możesz
                  zacząć tworzyć plany sprzątania (zakładka{" "}
                  <strong>Sprzątanie</strong>
                  ). W prawym górnym rogu możesz wybierać daty, na które
                  planujesz odświeżanie wybranych pokoi.
                </p>
                <p>
                  <strong>Uwaga!</strong> Jeśli uruchomisz synchronizację
                  (zakładka <strong>Synchronizacja</strong>
                  ), stworzona przez Ciebie struktura zostanie zastąpiona przez
                  stukturę pobraną z programu KWHotel.
                </p>
                <p>Do dzieła!</p>
                <p>
                  Skonfiguruj swój HotelCleanApp >>{" "}
                  <Link to="/settings">TUTAJ</Link>
                </p>
              </div>
            </Trans>
          </Message.Content>
        </Message>
      );
    return (
      <HotelStructure
        {...this.props}
        {...this.state}
        toggleModal={this.toggleModal}
      />
    );
  }
}
const mapStateToProps = state => {
  return {
    roomPhase: state.rooms.phase,
    occupancyPhase: state.occupancy.phase,
    user: state.account.user,
    users: state.users.data,
    rooms: getVisibleRooms(state),
    date: state.occupancy.date,
    roomsInfo: state.occupancy.data,
    cleaning: state.cleaning.data,
    isAdmin: isAdmin(state),
    isSynchronizing: isSynchronizing(state)
  };
};

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      ...roomsActions,
      getCleaningList,
      getSyncUser,
      getOccupancy,
      getUsers
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(HotelStructureContainer));



// WEBPACK FOOTER //
// ./src/rooms/HotelStructure/index.js